import { Flex, Dropdown, IconButton } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { LearnMore } from '@vibe/icons';

type Option = {
  label: string;
  value: string | number;
  leftIcon?: any | null;
};

type SelectSettingProps = {
  title: string;
  value: Option['value'] | null;
  options: Option[];
  onChange: (value: Option['value']) => void;
  setHelpState: any;
  settingCategory: string;
  setShowHelpModal?: any;
};

export function SelectSetting({ title, value, options, onChange, setHelpState, settingCategory, setShowHelpModal }: SelectSettingProps) {
  let selectedOption = options.find((option) => option.value === value);

  if (!selectedOption) {
    selectedOption = options[0];
  }

  return (
    <Flex direction="column" align="start" style={{ width: '100%' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        <small>{title}</small>
        {setShowHelpModal ? (
          <IconButton
            className="CustomHelpButton"
            icon={LearnMore}
            kind="tertiary"
            size="xxs"
            onClick={() => {
              setHelpState({ category: settingCategory, content: title.toLowerCase().replace(/[^a-z]/g, '_') });
              setShowHelpModal(true);
            }}
          />
        ) : null}
      </label>
      <Dropdown
        searchable
        className="CustomDropdown"
        onChange={(newOption: Option) => {
          newOption.value && onChange(newOption.value);
        }}
        size="medium"
        options={options}
        value={dropdownValue(selectedOption)}
        clearable={false}
      />
    </Flex>
  );
}
